<template>
  <div class="single-block-container">
    <RequestPasswordResetForm v-if="!token"></RequestPasswordResetForm>
    <PasswordResetForm v-else :token="token"></PasswordResetForm>
  </div>
</template>

<script>
import PasswordResetForm from 'CORE/components/users/password-reset'
import RequestPasswordResetForm from 'CORE/components/users/request-password-reset'
import { get } from 'lodash'

export default {
    components: {
        PasswordResetForm,
        RequestPasswordResetForm,
    },
    computed: {
        token() {
            return get(this.$route.query, 'token', null)
        },
    },
}
</script>
